import { IMessageType } from '@/services/signalr/types';
import { IConfigurationUpdateReqMsg } from '~/api/messages/IConfigurationUpdateReqMsg';
import { IConfigurationUpdateRespMsg } from '~/api/messages/IConfigurationUpdateRespMsg';
import { IConfigurationsReqMsg } from '~/api/messages/IConfigurationsReqMsg';
import { IConfigurationsRespMsg } from '~/api/messages/IConfigurationsRespMsg';

export const ConfigurationsReqMsg: IMessageType<IConfigurationsReqMsg, IConfigurationsRespMsg> = {
  requestName: 'ConfigurationsReqMsg',
  responseName: 'ConfigurationsRespMsg',
};

export const ConfigurationUpdateReqMsg: IMessageType<IConfigurationUpdateReqMsg, IConfigurationUpdateRespMsg> = {
  requestName: 'ConfigurationUpdateReqMsg',
  responseName: 'ConfigurationUpdateRespMsg',
};
